import config from "@/api/config"
import ApiClient from '@/api/ApiClient'

ApiClient.client().defaults.baseURL = config.makroApiUrl

export default {
    /**
     * Get Campaing by id|slug|nip
     *
     * @param {string} id
     * @returns {Promise}
     */
    getCampaign (id){
        return ApiClient.get(`/pl/api/campaigns/${id}`)
    },
    /**
     * Get halls list
     *
     * @returns {Promise}
     */
    getHalls () {
        return ApiClient.get('/pl/api/halls', {pagination: false})
    },
    /**
     * Submit card form
     *
     * @param {object} payload
     * @returns {Promise}
     */
    submitCard (payload) {
        return ApiClient.post('/api/card/registrations', payload)
    }
}
